<app-floorplan-item-details [floorplanItem]="airPath">
  <div data-main>
    <app-reference-measurement-item-length [floorplanItem]="airPath"></app-reference-measurement-item-length>
  </div>
</app-floorplan-item-details>
